"use client";

import { useEffect, useRef } from "react";
import { scrollToPageSection } from "./useCollectionScroll";

/** Anchor for the filtered results grid heading. */
export const FILTER_RESULTS_ID = "lifestyle-filter-results";

/**
 * Scrolls to the filtered results when the user changes a filter, so the new
 * grid is visible below the sticky bar. Skips the initial mount — including
 * URL hydration — so only user-driven changes trigger a jump.
 */
export default function useFilterResultsScroll(isDirty: boolean, resetKey: string) {
  const previousResetKey = useRef<string | null>(null);

  useEffect(() => {
    if (!isDirty) {
      previousResetKey.current = resetKey;
      return;
    }

    if (previousResetKey.current === null) {
      previousResetKey.current = resetKey;
      return;
    }

    if (previousResetKey.current === resetKey) return;

    previousResetKey.current = resetKey;

    const scroll = () => scrollToPageSection(FILTER_RESULTS_ID);
    if (scroll()) return;

    // The filtered grid mounts on the next frame when switching from the lobby.
    requestAnimationFrame(scroll);
  }, [isDirty, resetKey]);
}
